import {
  createContext,
  useCallback,
  useContext,
  useMemo,
  useState,
  useEffect,
} from "react";

const LanguageContext = createContext({
  language: "EN",
  setLanguage: () => {},
  toggleLanguage: () => {},
});

const getInitialLanguage = () => {
  if (typeof window === "undefined") {
    return "EN";
  }
  const storedLang = window.localStorage.getItem("preferredLanguage");
  return storedLang === "AR" ? "AR" : "EN";
};

export const LanguageProvider = ({ children }) => {
  const [language, setLanguage] = useState(() => {
    try {
      return getInitialLanguage();
    } catch {
      return "EN";
    }
  });

  useEffect(() => {
    try {
      window.localStorage.setItem("preferredLanguage", language);
    } catch {
      // ignore write errors (e.g., SSR or private mode)
    }
  }, [language]);

  const setLanguageSafe = useCallback((lang) => {
    setLanguage(lang === "AR" ? "AR" : "EN");
  }, []);

  const toggleLanguage = useCallback(() => {
    setLanguage((prev) => (prev === "EN" ? "AR" : "EN"));
  }, []);

  const value = useMemo(
    () => ({
      language,
      setLanguage: setLanguageSafe,
      toggleLanguage,
    }),
    [language, setLanguageSafe, toggleLanguage]
  );

  return (
    <LanguageContext.Provider value={value}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => useContext(LanguageContext);

export default LanguageContext;

